// export const host = "https://thamarai-hdceezejc8ekd9g4.southindia-01.azurewebsites.net/api/"
// export const host = "http://localhost:5000/api/"
// export const host = 'http://51.20.183.125:5000/api/';
export const host = "https://thiran.duckdns.org/api/";